import React from "react";
import { Routes, Route } from "react-router-dom";

// Import your page components
import Home from "./Pages/Home";
import About from "./Pages/About";
import Services from "./Pages/Services";
import Contact_Us from "./Pages/Contact_Us";
import Portfolio from "./Pages/Portfolio";
import Download from "./Pages/Download";
import Notifications from "./Pages/Notifications";


const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
       <Route path="/Home" element={<Home />} />
      <Route path="/about" element={<About />} />
      <Route path="/services" element={<Services />} />
      <Route path="/contact" element={<Contact_Us />} />
      <Route path="/portfolio" element={<Portfolio />} />
      <Route path="/Download" element={<Download />} />
      <Route path="/Notifications" element={<Notifications />} />
    </Routes>
  );
};

export default AppRoutes;
